import { DialogAction, PreparedDialogs } from './types';
import { LicenseStatus } from '@/api/services/user';
import AboutNeolexon from '@/components/SharedComponents/AboutNeolexon';
import { Kontakt } from '@/components/SharedComponents/CustomDropdown/Kontakt';
import { AccountDelete } from '@/components/SharedComponents/AccountDelete';
import { StarsDialog } from '@/components/StarsDialog';
import { LicenseExpired } from '@/components/LicenseExpired';
import { SelectHealthInsurance } from '@/screens/LicenseBooking/SelectHealthInsurance';

export const PREPARED_DIALOGS: PreparedDialogs = {
  logoutDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Abmelden',
    content: 'Möchten Sie sich wirklich abmelden?',
    danger: true,
    confirmAction: {
      label: 'Abmelden',
      onPress,
    },
    showCancelButton: true,
  }),
  aboutNeolexonDialog: () => ({
    title: 'Über neolexon Aphasie',
    contentComponent: () => <AboutNeolexon />,
    cancelOnBackdropPress: true,
  }),
  kontaktDialog: () => ({
    title: 'Kontakt',
    contentComponent: () => <Kontakt />,
    cancelOnBackdropPress: true,
  }),
  accountDeleteDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Alle Daten unwiderruflich löschen',
    contentComponent: () => <AccountDelete />,
    confirmAction: {
      label: 'Unwiderruflich Löschen',
      onPress,
    },
    showCancelButton: true,
    danger: true,
  }),
  selectHealthInsuranceDialog: (onStop) => ({
    title: 'Lizenz buchen',
    contentComponent: () => <SelectHealthInsurance />,
    showOkButton: false,
    showCancelX: true,
  }),
  starsProgressDialog: ({
    minutesExercised,
    stars,
    patient,
    onConfirm,
    onStop,
  }) => {
    return {
      title: `Toll! Heute schon ${minutesExercised} Minuten geübt!`,
      contentComponent: () => <StarsDialog stars={stars} patient={patient} />,
      confirmAction: {
        label: 'Weiter',
        onPress: onConfirm,
      },
      cancelAction: {
        label: 'Stop',
        onPress: onStop,
      },
      showCancelButton: true,
      cancelOnBackdropPress: false,
    };
  },
  licenseExpiredDialog: (licenseStatus: LicenseStatus | null) => {
    const title =
      licenseStatus?.type === 'trial'
        ? 'Ihre Testphase ist zu Ende'
        : 'Lizenz abgelaufen';
    return {
      title,
      contentComponent: () => <LicenseExpired licenseStatus={licenseStatus} />,
      showOkButton: false,
      showCancelX: true,
    };
  },
  noInternetDialog: () => ({
    title: 'Keine Verbindung',
    content:
      'Keine Verbindung zum neolexon Server. Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
    danger: true,
  }),
};
